<!--
@Author: Calvin Green <calvin>
@Date:   2021-11-08T10:04:52+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-04-05T08:57:12+02:00
@Copyright: Diversitude 2022
-->



<template>
    <b-modal size="lg" hide-footer id="applicantModal" title="Applicant">
        <!--<form-plugin uid="6128e50084e04"></form-plugin>-->
        <b-overlay :show="is_loading">
            <b-row>
                <b-col cols="6" class="mb-3">
                    <label for="1">
                        Company Name
                    </label>
                    <b-form-input v-model="params.company_name"></b-form-input>
                </b-col>
                <b-col cols="6">
                    <label for="1">
                        Contact Person
                    </label>
                    <b-form-input v-model="params.contact_person"></b-form-input>
                </b-col>
                <b-col cols="6"  class="mb-3">
                    <label for="1">
                        Company Phone
                    </label>
                    <b-form-input type="tel" v-model="params.company_phone"></b-form-input>
                </b-col>
                <b-col cols="6">
                    <label for="1">
                        Company Email
                    </label>
                    <b-form-input type="email" v-model="params.company_email"></b-form-input>
                </b-col>
                <b-col cols="12" class="mb-3">
                    <label for="1">
                        Address
                    </label>
                    <b-form-textarea no-resize max-rows="4" rows="1" v-model="params.company_address"></b-form-textarea>
                </b-col>
                <b-col cols="6">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="params.licensed"
                      name="checkbox-1"
                    >
                      &nbsp;Licensed
                    </b-form-checkbox>
                </b-col>

                <b-col cols="6">
                    <label  for="">Module Type</label>
                    <b-form-select class="form-select" :options="modules" v-model="params.module_id"></b-form-select>
                </b-col>
            </b-row>
            <div class="w-100 mt-2 mb-2" >
                <b-button style="float: right;" variant="success" @click="save()">Save</b-button>
                <b-button class="me-2" style="float: right;" @click="$bvModal.hide('applicantModal')">Cancel</b-button>
            </div>
        </b-overlay>
    </b-modal>
</template>

<script>

import { ccbAdminState, ccbAdminMethods } from "@/state/helpers"
export default {
    data:() => ({
        params:{},
        is_loading: false
    }),
    computed:{
        ...ccbAdminState,
        modules(){
            let data = [];
            if(this.module_types != null){
                this.module_types.forEach(module => {
                    data.push({
                        value: module.id,
                        text: module.name,
                    })
                })
            }
            return data;
        }
    },
    methods:{
        ...ccbAdminMethods,
        save(){
            this.is_loading = true;
            this.addClient(this.params)
            .then(()=>{
                this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'Saved Configuration', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
                this.loadClients()
                .then(()=>{
                    this.$bvModal.hide('applicantModal');
                })

            })
            .catch(()=>{
                this.is_loading = false;
                console.log('Save Error')
            })
        }
    },
    mounted(){
        if(this.module_types == null){
            this.loadModuleTypes();
        }
    },
}
</script>

<style>

</style>
